var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.06083 8.97381L8.84623 8.97381L8.84623 10.3215L1.67662 10.3215L1.67662 8.97381L1.68764 8.97381L1.68763 3.08441L3.03535 3.08441L3.03536 7.92768L9.28451 1.67853L10.3203 2.71433L4.06083 8.97381Z",
    fill: "#3CE475"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIn);
export default __webpack_public_path__ + "static/media/transfer-in.dd00e8e58df6b243c2efd67bfe30521a.svg";
export { ForwardRef as ReactComponent };